import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";

import type { DashboardMembershipDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_MEMBERSHIP_DETAILS_LOADER } from "@application/loaders/dashboard_membership_details_loader";
import { DASHBOARD_MEMBERSHIPS_LIST_LOADER } from "@application/loaders/dashboard_memberships_list_loader";

import { DASHBOARD_USERS_LINK } from "@application/navigation/dashboard_users_link";

import { Loader } from "@styled/loader";

const DashboardInviteForm = lazy(() =>
  import("./invite_form").then((m) => ({ default: m.DashboardInviteForm })),
);
const DashboardMembershipDetails = lazy(() =>
  import("./membership_details").then((m) => ({
    default: m.DashboardMembershipDetails,
  })),
);
const DashboardMembershipEdit = lazy(() =>
  import("./membership_edit").then((m) => ({
    default: m.DashboardMembershipEdit,
  })),
);
const DashboardMembershipsList = lazy(() =>
  import("./memberships_list").then((m) => ({
    default: m.DashboardMembershipsList,
  })),
);

export const DASHBOARD_USERS_ROUTE = {
  path: "users",
  handle: DASHBOARD_USERS_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardMembershipsList />
        </Suspense>
      ),
      loader: DASHBOARD_MEMBERSHIPS_LIST_LOADER,
    },
    {
      path: "invite",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardInviteForm />
        </Suspense>
      ),
      handle: {
        name: "Invite",
        to: "/dashboard/users/invite",
      },
    },
    {
      path: ":id",
      handle: (data: DashboardMembershipDetailsQuery): Breadcrumb => ({
        name: data.membership.user.name,
        to: `/dashboard/users/${data.membership.user.id}`,
      }),
      loader: DASHBOARD_MEMBERSHIP_DETAILS_LOADER,
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardMembershipDetails />
            </Suspense>
          ),
          loader: DASHBOARD_MEMBERSHIP_DETAILS_LOADER,
        },
        {
          path: "edit",
          element: (
            <Suspense fallback={<Loader />}>
              <DashboardMembershipEdit />
            </Suspense>
          ),
          loader: DASHBOARD_MEMBERSHIP_DETAILS_LOADER,
          handle: (data: DashboardMembershipDetailsQuery): Breadcrumb => ({
            name: "Edit",
            to: `/dashboard/users/${data.membership.user.id}`,
          }),
        },
      ],
    },
  ],
} satisfies RouteObject;
